export const socketEvents = {
  connect: 'connect',
  connectError: 'connect_error',
  livenessCheckResult: 'liveness_check_result',
  userOpenLivenessCheck: 'user_open_liveness_check',
  userCannotStartInstantApp: 'user_cannot_start_instant_app',
  disconnect: 'disconnect',
};
